import { payrollConfigApiBaseUrl } from '../../shared/env';
import { createJsonClient } from '../../shared/httpClient';
import type { TaxPaymentSettingsGateway } from './TaxPaymentSettingsGateway';
import type {
  AddStateTaxEntryRequest, EmployerTaxDetails, SaveEmployerTaxDetailRequest, StateTaxHistoryItem, StateTaxSetup, TaxPaymentSettingsOverview,
} from './types';

export class HttpTaxPaymentSettingsGateway implements TaxPaymentSettingsGateway {
  private readonly request = createJsonClient(payrollConfigApiBaseUrl);

  getOverview(signal?: AbortSignal): Promise<TaxPaymentSettingsOverview> {
    return this.request('/api/tax-payment-settings/overview', undefined, signal);
  }

  getEmployerDetails(jurisdictionKey: string, signal?: AbortSignal): Promise<EmployerTaxDetails> {
    return this.request(`/api/tax-payment-settings/${encodeURIComponent(jurisdictionKey)}/employer-details`, undefined, signal);
  }

  saveEmployerDetails(jurisdictionKey: string, body: SaveEmployerTaxDetailRequest): Promise<EmployerTaxDetails> {
    return this.request(`/api/tax-payment-settings/${encodeURIComponent(jurisdictionKey)}/employer-details`, {
      method: 'PUT',
      body: JSON.stringify(body),
    });
  }

  getStateTax(jurisdictionKey: string, signal?: AbortSignal): Promise<StateTaxSetup> {
    return this.request(`/api/tax-payment-settings/${encodeURIComponent(jurisdictionKey)}/state-tax`, undefined, signal);
  }

  addStateTaxEntry(jurisdictionKey: string, body: AddStateTaxEntryRequest): Promise<StateTaxSetup> {
    return this.request(`/api/tax-payment-settings/${encodeURIComponent(jurisdictionKey)}/state-tax/entries`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  }

  reviewStateTax(jurisdictionKey: string): Promise<StateTaxSetup> {
    return this.request(`/api/tax-payment-settings/${encodeURIComponent(jurisdictionKey)}/state-tax/review`, { method: 'POST', body: JSON.stringify({}) });
  }

  removeStateTaxEntry(jurisdictionKey: string, entryId: string): Promise<StateTaxSetup> {
    return this.request(`/api/tax-payment-settings/${encodeURIComponent(jurisdictionKey)}/state-tax/entries/${encodeURIComponent(entryId)}`, {
      method: 'DELETE',
    });
  }

  getStateTaxHistory(jurisdictionKey: string, signal?: AbortSignal): Promise<StateTaxHistoryItem[]> {
    return this.request(`/api/tax-payment-settings/${encodeURIComponent(jurisdictionKey)}/state-tax/history`, undefined, signal);
  }
}
